// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import JobsList from './PageComponent/JobsList';

function Jobs() {

    useMeta({
        title: 'Career | Marvel Blinds',
        description: 'Dynamic careers await at Marvel Lifestyle! Review available positions and take the first step towards a fulfilling professional path today',
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/career/jobs/`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Career | Marvel Blinds',
            description:
                'Dynamic careers await at Marvel Lifestyle! Review available positions and take the first step towards a fulfilling professional path today',
            url: `${process.env.REACT_APP_WEBSITE_URL}/career/jobs/`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <JobsList />
            <Footer />
        </div>
    );
}

export default Jobs;
